import React from 'react'
import { Icon } from '@iconify/react';

export default function Skills() {
  return (
    <>
<div className="row w-100 m-auto my-5 py-5 g-4">
  {/*-------------------------------------------Head of CARDs-------------------------------------------------*/}
<div className="col-md-12">
  <p className='text-center'><strong className='fs-5'>“ Hey,</strong> you are here in the skills section where you found both of personal and technical skills <strong className='fs-5'>”</strong></p>
</div>
  {/*-------------------------------------------HTML CARD---------------------------------------------------*/}
  <div className="col-md-4"> 
  <div className="card border-dark mb-3 h-100">
  <div className="card-header text-dark text-center"><i className="fa-solid fa-code"></i></div>
  <div className="card-body text-dark">
    <h5 className="card-title text-center fw-bolder mb-3">HTML</h5>
    <p className="card-text text-center">“In-depth knowledge of front-end coding languages including HTML with clean code”</p>
  </div>
</div>
</div>
  {/*-------------------------------------------CSS CARD---------------------------------------------------*/}

<div className="col-md-4"> 
  <div className="card border-dark mb-3 h-100">
  <div className="card-header text-dark text-center"><i className="fa-brands fa-css3"></i></div>
  <div className="card-body text-dark">
    <h5 className="card-title text-center fw-bolder mb-3">CSS</h5>
    <p className="card-text text-center">“In-depth knowledge of front-end coding languages including CSS”</p>
  </div>
</div>
</div>

 {/*------------------------------------------Bootstrap CARD-------------------------------------------------*/}

 <div className="col-md-4"> 
  <div className="card border-dark mb-3 h-100">
  <div className="card-header text-dark text-center"><i className="fa-brands fa-bootstrap"></i></div>
  <div className="card-body text-dark">
    <h5 className="card-title text-center fw-bolder mb-3">Bootstrap</h5>
    <p className="card-text text-center">“Design and develop software applications using Bootstrap”</p>
  </div>
</div>
</div>

 {/*------------------------------------------jQuery CARD-------------------------------------------------*/}

 <div className="col-md-4"> 
  <div className="card border-dark mb-3 h-100">
  <div className="card-header text-dark text-center"><Icon icon="simple-icons:jquery" /></div>
  <div className="card-body text-dark">
    <h5 className="card-title text-center fw-bolder mb-3">jQuery</h5>
    <p className="card-text text-center">“Strong understanding of features and utility functions of jQuery”</p>
  </div>
</div>
</div>

 {/*------------------------------------------JAVASCRIPT CARD-------------------------------------------------*/}

 <div className="col-md-4"> 
  <div className="card border-dark mb-3 h-100">
  <div className="card-header text-dark text-center"><Icon icon="simple-icons:javascript" /></div>
  <div className="card-body text-dark">
    <h5 className="card-title text-center fw-bolder mb-3">JavaScript</h5>
    <p className="card-text text-center">“completing the design of applications using JavaScript programming language with clear understanding by new features of ES6 ”</p>
  </div>
</div>
</div>

 {/*------------------------------------------TypeSCRIPT CARD-------------------------------------------------*/}

 <div className="col-md-4"> 
  <div className="card border-dark mb-3 h-100">
  <div className="card-header text-dark text-center"><Icon icon="cib:typescript" /></div>
  <div className="card-body text-dark">
    <h5 className="card-title text-center fw-bolder mb-3">TypeScript</h5>
    <p className="card-text text-center">“A clear and comprehensive Typescript programming language developer”</p>
  </div>
</div>
</div>

 {/*------------------------------------------SCSS CARD-------------------------------------------------*/}

 <div className="col-md-4"> 
  <div className="card border-dark mb-3 h-100">
  <div className="card-header text-dark text-center"><i className="fa-brands fa-sass"></i></div>
  <div className="card-body text-dark">
    <h5 className="card-title text-center fw-bolder mb-3">SASS/SCSS</h5>
    <p className="card-text text-center">“Using Scss and responsive grid system, Create a modern looking responsive website”</p>
  </div>
</div>
</div>

{/*------------------------------------------React CARD-------------------------------------------------*/}

<div className="col-md-4"> 
  <div className="card border-dark mb-3 h-100">
  <div className="card-header text-dark text-center"><i className="fa-brands fa-react"></i></div>
  <div className="card-body text-dark">
    <h5 className="card-title text-center fw-bolder mb-3">React</h5>
    <p className="card-text text-center">“Strong proficiency in JavaScript, including DOM manipulation and the JavaScript object model · Thorough understanding of React”</p>
  </div>
</div>
</div>

{/*------------------------------------------Redux CARD-------------------------------------------------*/}

<div className="col-md-4"> 
  <div className="card border-dark mb-3 h-100">
  <div className="card-header text-dark text-center"><Icon icon="simple-icons:redux" /></div>
  <div className="card-body text-dark">
    <h5 className="card-title text-center fw-bolder mb-3">Redux</h5>
    <p className="card-text text-center">“Develop high performance customer facing e-commerce application using ReactJS, Redux”</p>
  </div>
</div>
</div>

{/*------------------------------------------API CARD-------------------------------------------------*/}

<div className="col-md-4"> 
  <div className="card border-dark mb-3 h-100">
  <div className="card-header text-dark text-center"><Icon icon="carbon:api-1" /></div>
  <div className="card-body text-dark">
    <h5 className="card-title text-center fw-bolder mb-3">Rest API</h5>
    <p className="card-text text-center">“Strong understanding and usage of Api as setter or getter”</p>
  </div>
</div>
</div>

{/*------------------------------------------Github CARD-------------------------------------------------*/}

<div className="col-md-4"> 
  <div className="card border-dark mb-3 h-100">
  <div className="card-header text-dark text-center"><i className="fa-brands fa-github"></i></div>
  <div className="card-body text-dark">
    <h5 className="card-title text-center fw-bolder mb-3">Github</h5>
    <p className="card-text text-center">“Strong understanding and using for GitHub and adding or editing and cloning projects”</p>
  </div>
</div>
</div>

{/*------------------------------------------Trello CARD-------------------------------------------------*/}

<div className="col-md-4"> 
  <div className="card border-dark mb-3 h-100">
  <div className="card-header text-dark text-center"><i className="fa-brands fa-trello"></i></div>
  <div className="card-body text-dark">
    <h5 className="card-title text-center fw-bolder mb-3">Trello</h5>
    <p className="card-text text-center">“Strong understanding and using the features of Trello”</p>
  </div>
</div>
</div>

{/*------------------------------------------Adobe CARD-------------------------------------------------*/}

<div className="col-md-4"> 
  <div className="card border-dark mb-3 h-100">
  <div className="card-header text-dark text-center"><Icon icon="cib:adobe-acrobat-reader" /></div>
  <div className="card-body text-dark">
    <h5 className="card-title text-center fw-bolder mb-3">Adobe XD & Photoshop</h5>
    <p className="card-text text-center">“Strong understanding for Adobe programs as Adobe-Photoshop & Adobe-XD”</p>
  </div>
</div>
</div>



</div>
    </>
  )
}
